export const popups = [
  {
    "State": "Alabama",
    "Index": 1,
    "Lat": 32.31823,
    "Long": -86.902298,
    "ProjectTotal": 2,
    "BridgeDeckArea": 0,
    "PavementDistance": 3,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "Alaska",
    "Index": 2,
    "Lat": 66.160507,
    "Long": -153.36914,
    "ProjectTotal": 3,
    "BridgeDeckArea": 805097,
    "PavementDistance": 270,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/alaska/"
  },
  {
    "State": "Arizona",
    "Index": 3,
    "Lat": 34.048927,
    "Long": -111.09374,
    "ProjectTotal": 5,
    "BridgeDeckArea": 1074539,
    "PavementDistance": 1323,
    "PavementStructureEvaluation": 4,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/arizona/"
  },
  {
    "State": "Arkansas",
    "Index": 4,
    "Lat": 34.799999,
    "Long": -92.199997,
    "ProjectTotal": 4,
    "BridgeDeckArea": 177350,
    "PavementDistance": 26,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/arkansas/"
  },
  {
    "State": "California",
    "Index": 5,
    "Lat": 36.778259,
    "Long": -119.41793,
    "ProjectTotal": 20,
    "BridgeDeckArea": 2196185,
    "PavementDistance": 695,
    "PavementStructureEvaluation": 15,
    "BridgeDeckScanning": 3,
    "OtherProjects": 1,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/california/"
  },
  {
    "State": "Colorado",
    "Index": 6,
    "Lat": 39.113014,
    "Long": -105.35889,
    "ProjectTotal": 5,
    "BridgeDeckArea": 109693,
    "PavementDistance": 670,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 1,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/colorado/"
  },
  {
    "State": "Connecticut",
    "Index": 7,
    "Lat": 41.599998,
    "Long": -72.699997,
    "ProjectTotal": 34,
    "BridgeDeckArea": 3874257,
    "PavementDistance": 288,
    "PavementStructureEvaluation": 8,
    "BridgeDeckScanning": 23,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 3,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/connecticut/"
  },
  {
    "State": "Delaware",
    "Index": 8,
    "Lat": 39,
    "Long": -75.5,
    "ProjectTotal": 7,
    "BridgeDeckArea": 2076465,
    "PavementDistance": 2,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 5,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/delaware/"
  },
  {
    "State": "Florida",
    "Index": 9,
    "Lat": 27.994402,
    "Long": -81.760254,
    "ProjectTotal": 7,
    "BridgeDeckArea": 311422,
    "PavementDistance": 174,
    "PavementStructureEvaluation": 4,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/florida/"
  },
  {
    "State": "Georgia",
    "Index": 15,
    "Lat": 33.247875,
    "Long": -83.441162,
    "ProjectTotal": 42,
    "BridgeDeckArea": 136182,
    "PavementDistance": 1978,
    "PavementStructureEvaluation": 38,
    "BridgeDeckScanning": 4,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/georgia/"
  },
  {
    "State": "Hawaii",
    "Index": 11,
    "Lat": 19.741755,
    "Long": -155.84444,
    "ProjectTotal": 2,
    "BridgeDeckArea": 1389888,
    "PavementDistance": 11,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/hawaii/"
  },
  {
    "State": "Idaho",
    "Index": 12,
    "Lat": 44.068203,
    "Long": -114.74204,
    "ProjectTotal": 34,
    "BridgeDeckArea": 1469029,
    "PavementDistance": 1888,
    "PavementStructureEvaluation": 19,
    "BridgeDeckScanning": 14,
    "OtherProjects": 1,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/idaho/"
  },
  {
    "State": "Illinois",
    "Index": 13,
    "Lat": 40,
    "Long": -89,
    "ProjectTotal": 31,
    "BridgeDeckArea": 3534405,
    "PavementDistance": 413,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 26,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/illinois/"
  },
  {
    "State": "Indiana",
    "Index": 14,
    "Lat": 40.273502,
    "Long": -86.126976,
    "ProjectTotal": 10,
    "BridgeDeckArea": 3788176,
    "PavementDistance": 324,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 8,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/indiana/"
  },
  {
    "State": "Iowa",
    "Index": 15,
    "Lat": 42.032974,
    "Long": -93.581543,
    "ProjectTotal": 4,
    "BridgeDeckArea": 100288,
    "PavementDistance": 7,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/iowa/"
  },
  {
    "State": "Kansas",
    "Index": 16,
    "Lat": 38.5,
    "Long": -98,
    "ProjectTotal": 4,
    "BridgeDeckArea": 0,
    "PavementDistance": 59,
    "PavementStructureEvaluation": 4,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/kansas/"
  },
  {
    "State": "Kentucky",
    "Index": 17,
    "Lat": 37.839333,
    "Long": -84.27002,
    "ProjectTotal": 3,
    "BridgeDeckArea": 0,
    "PavementDistance": 50,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 2,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/kentucky/"
  },
  {
    "State": "Louisiana",
    "Index": 18,
    "Lat": 30.39183,
    "Long": -92.329102,
    "ProjectTotal": 5,
    "BridgeDeckArea": 887326,
    "PavementDistance": 244,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 3,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/louisiana/"
  },
  {
    "State": "Maine",
    "Index": 19,
    "Lat": 45.367584,
    "Long": -68.972168,
    "ProjectTotal": 13,
    "BridgeDeckArea": 775722,
    "PavementDistance": 18,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 10,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 1,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/maine/"
  },
  {
    "State": "Maryland",
    "Index": 20,
    "Lat": 39.045753,
    "Long": -76.641273,
    "ProjectTotal": 14,
    "BridgeDeckArea": 1937784,
    "PavementDistance": 592,
    "PavementStructureEvaluation": 6,
    "BridgeDeckScanning": 5,
    "OtherProjects": 1,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 1,
    "Blog": "https://infrasense.com/experience/maryland/"
  },
  {
    "State": "Massachusetts",
    "Index": 25,
    "Lat": 42.407211,
    "Long": -71.382439,
    "ProjectTotal": 95,
    "BridgeDeckArea": 682291,
    "PavementDistance": 76,
    "PavementStructureEvaluation": 9,
    "BridgeDeckScanning": 23,
    "OtherProjects": 6,
    "ConcreteStructureScanning": 25,
    "ConsultingResearch": 3,
    "SubsurfaceUtilityEngineering": 29,
    "Blog": "https://infrasense.com/experience/massachusetts/"
  },
  {
    "State": "Michigan",
    "Index": 22,
    "Lat": 44.182205,
    "Long": -84.506836,
    "ProjectTotal": 10,
    "BridgeDeckArea": 3619157,
    "PavementDistance": 124,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 5,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 2,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/michigan/"
  },
  {
    "State": "Minnesota",
    "Index": 23,
    "Lat": 46.39241,
    "Long": -94.63623,
    "ProjectTotal": 30,
    "BridgeDeckArea": 8468708,
    "PavementDistance": 2299,
    "PavementStructureEvaluation": 19,
    "BridgeDeckScanning": 10,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/minnesota/"
  },
  {
    "State": "Mississippi",
    "Index": 24,
    "Lat": 33,
    "Long": -90,
    "ProjectTotal": 1,
    "BridgeDeckArea": 0,
    "PavementDistance": 1000,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "Missouri",
    "Index": 25,
    "Lat": 38.573936,
    "Long": -92.60376,
    "ProjectTotal": 11,
    "BridgeDeckArea": 1438893,
    "PavementDistance": 16,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 8,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/missouri/"
  },
  {
    "State": "Montana",
    "Index": 26,
    "Lat": 46.96526,
    "Long": -109.53369,
    "ProjectTotal": 8,
    "BridgeDeckArea": 3195549,
    "PavementDistance": 27,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 6,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/montana/"
  },
  {
    "State": "Nebraska",
    "Index": 27,
    "Lat": 41.5,
    "Long": -100,
    "ProjectTotal": 2,
    "BridgeDeckArea": 135971,
    "PavementDistance": 0,
    "PavementStructureEvaluation": 0,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/nebraska/"
  },
  {
    "State": "Nevada",
    "Index": 28,
    "Lat": 39.876019,
    "Long": -117.22412,
    "ProjectTotal": 4,
    "BridgeDeckArea": 2480442,
    "PavementDistance": 13,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/nevada/"
  },
  {
    "State": "New Hampshire",
    "Index": 29,
    "Lat": 44,
    "Long": -71.5,
    "ProjectTotal": 14,
    "BridgeDeckArea": 489902,
    "PavementDistance": 205,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 7,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 1,
    "Blog": "https://infrasense.com/experience/newhampshire/"
  },
  {
    "State": "New Jersey",
    "Index": 30,
    "Lat": 39.833851,
    "Long": -74.871826,
    "ProjectTotal": 7,
    "BridgeDeckArea": 5507,
    "PavementDistance": 827,
    "PavementStructureEvaluation": 6,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/new-jersey/"
  },
  {
    "State": "New Mexico",
    "Index": 31,
    "Lat": 34.307144,
    "Long": -106.01807,
    "ProjectTotal": 1,
    "BridgeDeckArea": 0,
    "PavementDistance": 2,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/new-mexico/"
  },
  {
    "State": "New York",
    "Index": 32,
    "Lat": 43,
    "Long": -75,
    "ProjectTotal": 47,
    "BridgeDeckArea": 5937627,
    "PavementDistance": 148,
    "PavementStructureEvaluation": 6,
    "BridgeDeckScanning": 32,
    "OtherProjects": 2,
    "ConcreteStructureScanning": 5,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 2,
    "Blog": "https://infrasense.com/experience/new-york/"
  },
  {
    "State": "North Carolina",
    "Index": 33,
    "Lat": 35.782169,
    "Long": -80.793457,
    "ProjectTotal": 4,
    "BridgeDeckArea": 87928,
    "PavementDistance": 35,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "North Dakota",
    "Index": 34,
    "Lat": 47.650589,
    "Long": -100.43701,
    "ProjectTotal": 12,
    "BridgeDeckArea": 1340737,
    "PavementDistance": 4324,
    "PavementStructureEvaluation": 6,
    "BridgeDeckScanning": 4,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 1,
    "Blog": "https://infrasense.com/experience/northdakota/"
  },
  {
    "State": "Ohio",
    "Index": 35,
    "Lat": 40.367474,
    "Long": -82.996216,
    "ProjectTotal": 17,
    "BridgeDeckArea": 1528940,
    "PavementDistance": 111,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 12,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/ohio/"
  },
  {
    "State": "Oklahoma",
    "Index": 36,
    "Lat": 36.084621,
    "Long": -96.921387,
    "ProjectTotal": 4,
    "BridgeDeckArea": 0,
    "PavementDistance": 3682,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/oklahoma/"
  },
  {
    "State": "Oregon",
    "Index": 37,
    "Lat": 44,
    "Long": -120.5,
    "ProjectTotal": 5,
    "BridgeDeckArea": 2974312,
    "PavementDistance": 116,
    "PavementStructureEvaluation": 2,
    "BridgeDeckScanning": 3,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/oregon/"
  },
  {
    "State": "Pennsylvania",
    "Index": 38,
    "Lat": 41.203323,
    "Long": -77.194527,
    "ProjectTotal": 17,
    "BridgeDeckArea": 1133930,
    "PavementDistance": 237,
    "PavementStructureEvaluation": 4,
    "BridgeDeckScanning": 12,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 1,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/pennsylvania/"
  },
  {
    "State": "Rhode Island",
    "Index": 39,
    "Lat": 41.742325,
    "Long": -71.742332,
    "ProjectTotal": 14,
    "BridgeDeckArea": 3201456,
    "PavementDistance": 17,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 9,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/rhodeisland/"
  },
  {
    "State": "South Carolina",
    "Index": 40,
    "Lat": 33.836082,
    "Long": -81.163727,
    "ProjectTotal": 16,
    "BridgeDeckArea": 337067,
    "PavementDistance": 1249,
    "PavementStructureEvaluation": 13,
    "BridgeDeckScanning": 3,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/southcarolina/"
  },
  {
    "State": "South Dakota",
    "Index": 41,
    "Lat": 44.5,
    "Long": -100,
    "ProjectTotal": 4,
    "BridgeDeckArea": 81837,
    "PavementDistance": 24,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/southdakota/"
  },
  {
    "State": "Tennessee",
    "Index": 42,
    "Lat": 35.860119,
    "Long": -86.660156,
    "ProjectTotal": 5,
    "BridgeDeckArea": 470686,
    "PavementDistance": 2887,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/tennessee/"
  },
  {
    "State": "Texas",
    "Index": 44,
    "Lat": 31,
    "Long": -100,
    "ProjectTotal": 7,
    "BridgeDeckArea": 922278,
    "PavementDistance": 285,
    "PavementStructureEvaluation": 4,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 1,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/texas/"
  },
  {
    "State": "Utah",
    "Index": 44,
    "Lat": 39.41922,
    "Long": -111.95068,
    "ProjectTotal": 6,
    "BridgeDeckArea": 160960,
    "PavementDistance": 1981,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/utah/"
  },
  {
    "State": "Vermont",
    "Index": 45,
    "Lat": 44,
    "Long": -72.699997,
    "ProjectTotal": 5,
    "BridgeDeckArea": 0,
    "PavementDistance": 120,
    "PavementStructureEvaluation": 5,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/vermont/"
  },
  {
    "State": "Virginia",
    "Index": 46,
    "Lat": 37.926868,
    "Long": -78.024902,
    "ProjectTotal": 70,
    "BridgeDeckArea": 2924117,
    "PavementDistance": 4152,
    "PavementStructureEvaluation": 43,
    "BridgeDeckScanning": 19,
    "OtherProjects": 1,
    "ConcreteStructureScanning": 6,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/virginia/"
  },
  {
    "State": "Washington",
    "Index": 47,
    "Lat": 47.751076,
    "Long": -120.74014,
    "ProjectTotal": 2,
    "BridgeDeckArea": 22080,
    "PavementDistance": 0,
    "PavementStructureEvaluation": 0,
    "BridgeDeckScanning": 1,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/washington/"
  },
  {
    "State": "West Virginia",
    "Index": 48,
    "Lat": 39,
    "Long": -80.5,
    "ProjectTotal": 1,
    "BridgeDeckArea": 0,
    "PavementDistance": 20,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "Wisconsin",
    "Index": 49,
    "Lat": 44.5,
    "Long": -89.5,
    "ProjectTotal": 70,
    "BridgeDeckArea": 43057722,
    "PavementDistance": 146,
    "PavementStructureEvaluation": 3,
    "BridgeDeckScanning": 64,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 2,
    "ConsultingResearch": 1,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/wisconsin/"
  },
  {
    "State": "Wyoming",
    "Index": 50,
    "Lat": 43.07597,
    "Long": -107.29028,
    "ProjectTotal": 3,
    "BridgeDeckArea": 284219,
    "PavementDistance": 34,
    "PavementStructureEvaluation": 1,
    "BridgeDeckScanning": 2,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": "https://infrasense.com/experience/wyoming/"
  },
  {
    "State": "Puerto Rico",
    "Index": 51,
    "Lat": 18.2,
    "Long": -66.66,
    "ProjectTotal": 0,
    "BridgeDeckArea": 0,
    "PavementDistance": 0,
    "PavementStructureEvaluation": 0,
    "BridgeDeckScanning": 0,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "District of Columbia",
    "Index": 51,
    "Lat": 38.898,
    "Long": -77.04,
    "ProjectTotal": 3,
    "BridgeDeckArea": 481216,
    "PavementDistance": 0,
    "PavementStructureEvaluation": 0,
    "BridgeDeckScanning": 3,
    "OtherProjects": 0,
    "ConcreteStructureScanning": 0,
    "ConsultingResearch": 0,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  },
  {
    "State": "International Projects",
    "Index": 52,
    "Lat": 34.599507,
    "Long": -67.090337,
    "ProjectTotal": 20,
    "BridgeDeckArea": 424271,
    "PavementDistance": 7339,
    "PavementStructureEvaluation": 9,
    "BridgeDeckScanning": 5,
    "OtherProjects": 2,
    "ConcreteStructureScanning": 1,
    "ConsultingResearch": 3,
    "SubsurfaceUtilityEngineering": 0,
    "Blog": ""
  }
 ]


// export const popups = [
//   {
//     "State": "Alabama",
//     "Index": 1,
//     "Lat": 32.31823,
//     "Long": -86.902298,
//     "ProjectTotal": 2,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 3,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "Alaska",
//     "Index": 2,
//     "Lat": 66.160507,
//     "Long": -153.36914,
//     "ProjectTotal": 3,
//     "BridgeDeckArea": 805097,
//     "PavementDistance": 270,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/alaska/"
//   },
//   {
//     "State": "Arizona",
//     "Index": 3,
//     "Lat": 34.048927,
//     "Long": -111.09374,
//     "ProjectTotal": 5,
//     "BridgeDeckArea": 1074539,
//     "PavementDistance": 1323,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/arizona/"
//   },
//   {
//     "State": "Arkansas",
//     "Index": 4,
//     "Lat": 34.799999,
//     "Long": -92.199997,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 177350,
//     "PavementDistance": 26,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/arkansas/"
//   },
//   {
//     "State": "California",
//     "Index": 5,
//     "Lat": 36.778259,
//     "Long": -119.41793,
//     "ProjectTotal": 17,
//     "BridgeDeckArea": 2196185,
//     "PavementDistance": 563,
//     "PavementStructureEvaluation": 12,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/california/"
//   },
//   {
//     "State": "Colorado",
//     "Index": 6,
//     "Lat": 39.113014,
//     "Long": -105.35889,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 109693,
//     "PavementDistance": 630,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 1,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/colorado/"
//   },
//   {
//     "State": "Connecticut",
//     "Index": 7,
//     "Lat": 41.599998,
//     "Long": -72.699997,
//     "ProjectTotal": 31,
//     "BridgeDeckArea": 3810059,
//     "PavementDistance": 288,
//     "PavementStructureEvaluation": 8,
//     "BridgeDeckScanning": 21,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 2,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/connecticut/"
//   },
//   {
//     "State": "Delaware",
//     "Index": 8,
//     "Lat": 39,
//     "Long": -75.5,
//     "ProjectTotal": 7,
//     "BridgeDeckArea": 2076465,
//     "PavementDistance": 2,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 5,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/delaware/"
//   },
//   {
//     "State": "Florida",
//     "Index": 9,
//     "Lat": 27.994402,
//     "Long": -81.760254,
//     "ProjectTotal": 6,
//     "BridgeDeckArea": 311422,
//     "PavementDistance": 134,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/florida/"
//   },
//   {
//     "State": "Georgia",
//     "Index": 15,
//     "Lat": 33.247875,
//     "Long": -83.441162,
//     "ProjectTotal": 31,
//     "BridgeDeckArea": 136182,
//     "PavementDistance": 1336,
//     "PavementStructureEvaluation": 28,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/georgia/"
//   },
//   {
//     "State": "Hawaii",
//     "Index": 11,
//     "Lat": 19.741755,
//     "Long": -155.84444,
//     "ProjectTotal": 2,
//     "BridgeDeckArea": 1389888,
//     "PavementDistance": 11,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/hawaii/"
//   },
//   {
//     "State": "Idaho",
//     "Index": 12,
//     "Lat": 44.068203,
//     "Long": -114.74204,
//     "ProjectTotal": 34,
//     "BridgeDeckArea": 1469029,
//     "PavementDistance": 1888,
//     "PavementStructureEvaluation": 19,
//     "BridgeDeckScanning": 14,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/idaho/"
//   },
//   {
//     "State": "Illinois",
//     "Index": 13,
//     "Lat": 40,
//     "Long": -89,
//     "ProjectTotal": 29,
//     "BridgeDeckArea": 3510992,
//     "PavementDistance": 413,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 24,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/illinois/"
//   },
//   {
//     "State": "Indiana",
//     "Index": 14,
//     "Lat": 40.273502,
//     "Long": -86.126976,
//     "ProjectTotal": 8,
//     "BridgeDeckArea": 1025723,
//     "PavementDistance": 324,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 6,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/indiana/"
//   },
//   {
//     "State": "Iowa",
//     "Index": 15,
//     "Lat": 42.032974,
//     "Long": -93.581543,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 100288,
//     "PavementDistance": 7,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/iowa/"
//   },
//   {
//     "State": "Kansas",
//     "Index": 16,
//     "Lat": 38.5,
//     "Long": -98,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 59,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/kansas/"
//   },
//   {
//     "State": "Kentucky",
//     "Index": 17,
//     "Lat": 37.839333,
//     "Long": -84.27002,
//     "ProjectTotal": 3,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 50,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 2,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/kentucky/"
//   },
//   {
//     "State": "Louisiana",
//     "Index": 18,
//     "Lat": 30.39183,
//     "Long": -92.329102,
//     "ProjectTotal": 5,
//     "BridgeDeckArea": 887326,
//     "PavementDistance": 244,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/louisiana/"
//   },
//   {
//     "State": "Maine",
//     "Index": 19,
//     "Lat": 45.367584,
//     "Long": -68.972168,
//     "ProjectTotal": 13,
//     "BridgeDeckArea": 775722,
//     "PavementDistance": 18,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 10,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 1,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/maine/"
//   },
//   {
//     "State": "Maryland",
//     "Index": 20,
//     "Lat": 39.045753,
//     "Long": -76.641273,
//     "ProjectTotal": 11,
//     "BridgeDeckArea": 1022373,
//     "PavementDistance": 591,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 1,
//     "Blog": "https://infrasense.com/experience/maryland/"
//   },
//   {
//     "State": "Massachusetts",
//     "Index": 25,
//     "Lat": 42.407211,
//     "Long": -71.382439,
//     "ProjectTotal": 68,
//     "BridgeDeckArea": 649138,
//     "PavementDistance": 73,
//     "PavementStructureEvaluation": 6,
//     "BridgeDeckScanning": 18,
//     "OtherProjects": 4,
//     "ConcreteStructureScanning": 20,
//     "ConsultingResearch": 3,
//     "SubsurfaceUtilityEngineering": 17,
//     "Blog": "https://infrasense.com/experience/massachusetts/"
//   },
//   {
//     "State": "Michigan",
//     "Index": 22,
//     "Lat": 44.182205,
//     "Long": -84.506836,
//     "ProjectTotal": 10,
//     "BridgeDeckArea": 3619157,
//     "PavementDistance": 124,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 5,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 2,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/michigan/"
//   },
//   {
//     "State": "Minnesota",
//     "Index": 23,
//     "Lat": 46.39241,
//     "Long": -94.63623,
//     "ProjectTotal": 28,
//     "BridgeDeckArea": 4478065,
//     "PavementDistance": 2287,
//     "PavementStructureEvaluation": 18,
//     "BridgeDeckScanning": 9,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/minnesota/"
//   },
//   {
//     "State": "Mississippi",
//     "Index": 24,
//     "Lat": 33,
//     "Long": -90,
//     "ProjectTotal": 2,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 344,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "Missouri",
//     "Index": 25,
//     "Lat": 38.573936,
//     "Long": -92.60376,
//     "ProjectTotal": 7,
//     "BridgeDeckArea": 857839,
//     "PavementDistance": 16,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 5,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/missouri/"
//   },
//   {
//     "State": "Montana",
//     "Index": 26,
//     "Lat": 46.96526,
//     "Long": -109.53369,
//     "ProjectTotal": 7,
//     "BridgeDeckArea": 2784725,
//     "PavementDistance": 27,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 5,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/montana/"
//   },
//   {
//     "State": "Nebraska",
//     "Index": 27,
//     "Lat": 41.5,
//     "Long": -100,
//     "ProjectTotal": 2,
//     "BridgeDeckArea": 135971,
//     "PavementDistance": 0,
//     "PavementStructureEvaluation": 0,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/nebraska/"
//   },
//   {
//     "State": "Nevada",
//     "Index": 28,
//     "Lat": 39.876019,
//     "Long": -117.22412,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 2480442,
//     "PavementDistance": 13,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/nevada/"
//   },
//   {
//     "State": "New Hampshire",
//     "Index": 29,
//     "Lat": 44,
//     "Long": -71.5,
//     "ProjectTotal": 12,
//     "BridgeDeckArea": 476486,
//     "PavementDistance": 205,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 6,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 1,
//     "Blog": "https://infrasense.com/experience/newhampshire/"
//   },
//   {
//     "State": "New Jersey",
//     "Index": 30,
//     "Lat": 39.833851,
//     "Long": -74.871826,
//     "ProjectTotal": 5,
//     "BridgeDeckArea": 660,
//     "PavementDistance": 778,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/new-jersey/"
//   },
//   {
//     "State": "New Mexico",
//     "Index": 31,
//     "Lat": 34.307144,
//     "Long": -106.01807,
//     "ProjectTotal": 1,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 2,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/new-mexico/"
//   },
//   {
//     "State": "New York",
//     "Index": 32,
//     "Lat": 43,
//     "Long": -75,
//     "ProjectTotal": 42,
//     "BridgeDeckArea": 5435112,
//     "PavementDistance": 146,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 30,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 5,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 1,
//     "Blog": "https://infrasense.com/experience/new-york/"
//   },
//   {
//     "State": "North Carolina",
//     "Index": 33,
//     "Lat": 35.782169,
//     "Long": -80.793457,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 87928,
//     "PavementDistance": 35,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "North Dakota",
//     "Index": 34,
//     "Lat": 47.650589,
//     "Long": -100.43701,
//     "ProjectTotal": 12,
//     "BridgeDeckArea": 1340737,
//     "PavementDistance": 4324,
//     "PavementStructureEvaluation": 6,
//     "BridgeDeckScanning": 4,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 1,
//     "Blog": "https://infrasense.com/experience/northdakota/"
//   },
//   {
//     "State": "Ohio",
//     "Index": 35,
//     "Lat": 40.367474,
//     "Long": -82.996216,
//     "ProjectTotal": 16,
//     "BridgeDeckArea": 1451213,
//     "PavementDistance": 111,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 11,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/ohio/"
//   },
//   {
//     "State": "Oklahoma",
//     "Index": 36,
//     "Lat": 36.084621,
//     "Long": -96.921387,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 3682,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/oklahoma/"
//   },
//   {
//     "State": "Oregon",
//     "Index": 37,
//     "Lat": 44,
//     "Long": -120.5,
//     "ProjectTotal": 5,
//     "BridgeDeckArea": 2974312,
//     "PavementDistance": 116,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/oregon/"
//   },
//   {
//     "State": "Pennsylvania",
//     "Index": 38,
//     "Lat": 41.203323,
//     "Long": -77.194527,
//     "ProjectTotal": 17,
//     "BridgeDeckArea": 1133930,
//     "PavementDistance": 237,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 12,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 1,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/pennsylvania/"
//   },
//   {
//     "State": "Rhode Island",
//     "Index": 39,
//     "Lat": 41.742325,
//     "Long": -71.742332,
//     "ProjectTotal": 12,
//     "BridgeDeckArea": 3184609,
//     "PavementDistance": 17,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 7,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/rhodeisland/"
//   },
//   {
//     "State": "South Carolina",
//     "Index": 40,
//     "Lat": 33.836082,
//     "Long": -81.163727,
//     "ProjectTotal": 15,
//     "BridgeDeckArea": 337067,
//     "PavementDistance": 1236,
//     "PavementStructureEvaluation": 12,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/southcarolina/"
//   },
//   {
//     "State": "South Dakota",
//     "Index": 41,
//     "Lat": 44.5,
//     "Long": -100,
//     "ProjectTotal": 3,
//     "BridgeDeckArea": 81837,
//     "PavementDistance": 24,
//     "PavementStructureEvaluation": 2,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/southdakota/"
//   },
//   {
//     "State": "Tennessee",
//     "Index": 42,
//     "Lat": 35.860119,
//     "Long": -86.660156,
//     "ProjectTotal": 5,
//     "BridgeDeckArea": 470686,
//     "PavementDistance": 2887,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/tennessee/"
//   },
//   {
//     "State": "Texas",
//     "Index": 44,
//     "Lat": 31,
//     "Long": -100,
//     "ProjectTotal": 6,
//     "BridgeDeckArea": 922278,
//     "PavementDistance": 140,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 1,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/texas/"
//   },
//   {
//     "State": "Utah",
//     "Index": 44,
//     "Lat": 39.41922,
//     "Long": -111.95068,
//     "ProjectTotal": 6,
//     "BridgeDeckArea": 160960,
//     "PavementDistance": 1981,
//     "PavementStructureEvaluation": 5,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/utah/"
//   },
//   {
//     "State": "Vermont",
//     "Index": 45,
//     "Lat": 44,
//     "Long": -72.699997,
//     "ProjectTotal": 4,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 99,
//     "PavementStructureEvaluation": 4,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/vermont/"
//   },
//   {
//     "State": "Virginia",
//     "Index": 46,
//     "Lat": 37.926868,
//     "Long": -78.024902,
//     "ProjectTotal": 65,
//     "BridgeDeckArea": 2924117,
//     "PavementDistance": 3908,
//     "PavementStructureEvaluation": 38,
//     "BridgeDeckScanning": 19,
//     "OtherProjects": 1,
//     "ConcreteStructureScanning": 6,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/virginia/"
//   },
//   {
//     "State": "Washington",
//     "Index": 47,
//     "Lat": 47.751076,
//     "Long": -120.74014,
//     "ProjectTotal": 2,
//     "BridgeDeckArea": 22080,
//     "PavementDistance": 0,
//     "PavementStructureEvaluation": 0,
//     "BridgeDeckScanning": 1,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/washington/"
//   },
//   {
//     "State": "West Virginia",
//     "Index": 48,
//     "Lat": 39,
//     "Long": -80.5,
//     "ProjectTotal": 1,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 20,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "Wisconsin",
//     "Index": 49,
//     "Lat": 44.5,
//     "Long": -89.5,
//     "ProjectTotal": 67,
//     "BridgeDeckArea": 39737242,
//     "PavementDistance": 146,
//     "PavementStructureEvaluation": 3,
//     "BridgeDeckScanning": 61,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 2,
//     "ConsultingResearch": 1,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/wisconsin/"
//   },
//   {
//     "State": "Wyoming",
//     "Index": 50,
//     "Lat": 43.07597,
//     "Long": -107.29028,
//     "ProjectTotal": 3,
//     "BridgeDeckArea": 284219,
//     "PavementDistance": 34,
//     "PavementStructureEvaluation": 1,
//     "BridgeDeckScanning": 2,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": "https://infrasense.com/experience/wyoming/"
//   },
//   {
//     "State": "Puerto Rico",
//     "Index": 51,
//     "Lat": 18.2,
//     "Long": -66.66,
//     "ProjectTotal": 0,
//     "BridgeDeckArea": 0,
//     "PavementDistance": 0,
//     "PavementStructureEvaluation": 0,
//     "BridgeDeckScanning": 0,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "District of Columbia",
//     "Index": 52,
//     "Lat": 38.898,
//     "Long": -77.04,
//     "ProjectTotal": 3,
//     "BridgeDeckArea": 481216,
//     "PavementDistance": 0,
//     "PavementStructureEvaluation": 0,
//     "BridgeDeckScanning": 3,
//     "OtherProjects": 0,
//     "ConcreteStructureScanning": 0,
//     "ConsultingResearch": 0,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   },
//   {
//     "State": "International Projects",
//     "Index": 53,
//     "Lat": 34.599507,
//     "Long": -67.090337,
//     "ProjectTotal": 19,
//     "BridgeDeckArea": 424271,
//     "PavementDistance": 5645,
//     "PavementStructureEvaluation": 8,
//     "BridgeDeckScanning": 5,
//     "OtherProjects": 2,
//     "ConcreteStructureScanning": 1,
//     "ConsultingResearch": 3,
//     "SubsurfaceUtilityEngineering": 0,
//     "Blog": ""
//   }
//  ]